<template>
    <div
        v-if="showInfoText"
        class="info-area">
        <InfoItem
            :title="'姓名'"
            :value="displayName"
            :isFirst="true"
        />
        <InfoItem
            :title="'待处理任务数'"
            :value="identifyingPersonalStats.NewOrders"
        />
        <InfoItem
            :title="'今日识别'"
            :value="identifyingPersonalStats.MarkedOrders"
        />
<!--        <InfoItem-->
<!--            :title="'目前排名'"-->
<!--            :value="rank"-->
<!--        />-->
        <InfoItem
            :title="'识别时间'"
            :value="orderIdentificationTime"
        />
        <div class="info-item-split-line"/>
        <div class="info-item" v-if="isImportant">
            <div>
                <a-tag color="#ff2121">重要！</a-tag>
            </div>
        </div>
        <div class="order-info">
            订单号: {{ consumerOrderId }}
        </div>
    </div>
</template>

<script>
 import InfoItem from "./InfoItem.vue"

 import { formatSecondWithoutUnit } from "../util/time.js"
 import { mapGetters } from 'vuex'
 import Vue from "vue"
 import Tag from "ant-design-vue/lib/tag"
 Vue.component(Tag.name, Tag)

 export default {
     name: 'InfoArea',
     props: {
     },
     computed: {
         ...mapGetters([
             "consumerOrderId",
             "priority",
             "showInfoText",
             "identifyingPersonalStats"
         ]),
         orderIdentificationTime: function() {
             return formatSecondWithoutUnit(this.$store.getters.orderIdentificationTime)
         },
         displayName: function() {
             if (this.identifyingPersonalStats.DisplayName == "") {
                 return "--"
             } else {
                 return this.identifyingPersonalStats.DisplayName
             }
         },
         isImportant: function() {
              if (this.priority >= 90) {
                  return true
              } else {
                  return false
              }
          },
         rank: function() {
             if (this.identifyingPersonalStats.Rank == 0) {
                 return "--"
             } else {
                 return this.identifyingPersonalStats.Rank
             }
         }
     },
     components: {
         InfoItem
     },
     methods: {
     }
 }
</script>

<style scoped>
 .info-area {
    color: #AAA;
    z-index: 5;
    padding-top: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: 80px;
}

 .info-item-area {
     display: flex;
     flex-direction: row;
     align-items: center;
     margin-left: 20px;
     margin-right: 80px;
 }

 .info-item-split-line {
     background-color: #333;
     width: 1px;
     height: 26px;
     margin-right: 10px;
 }

 .title {
     font-size: 12px;
     color: #AAA;
 }

 .time {
     font-size: 24px;
     color: #FFF;
 }

 .version-info {
     position: absolute;
     right: 80px;
     top: 10px;
     color: #666;
 }

 .order-info {
     /* position: absolute;
     right: 20px;
     top: 10px; */
     color: #666;
 }
</style>
